import { FormControl, FormLabel, Slider } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useElementTracking } from "../../../analytics/analytics";

import type { ElementTracking } from "../../../analytics/analytics";
import type { FormControlLabelProps, SliderProps } from "@mui/material";
import type { CSSProperties } from "react";
import type { FieldValues, Path } from "react-hook-form";

interface Props<TFieldValues extends FieldValues> {
  name: Path<TFieldValues>;
  label?: string;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
  formControlStyle?: CSSProperties;
}

export const CeSlider = <TFieldValues extends FieldValues>({
  name,
  label,
  formControlStyle,
  analyticsCategory,
  ...sliderProps
}: Props<TFieldValues> & SliderProps & ElementTracking): React.JSX.Element => {
  const { control } = useFormContext<TFieldValues>();
  const analyticsProps = useElementTracking(analyticsCategory, name, "slider");

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl style={formControlStyle}>
          <FormLabel id={`${name}-label`}>{label}</FormLabel>
          <Slider
            id={`${name}-slider`}
            onChange={field.onChange}
            value={field.value}
            valueLabelFormat={(val) => `${val}px`}
            valueLabelDisplay="auto"
            aria-labelledby="label-padding"
            slotProps={{
              input: analyticsProps,
            }}
            {...sliderProps}
          />
        </FormControl>
      )}
    />
  );
};
